import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { CreditCardService } from '@bari/core/services/credit-card.service';
import { BaseModalService } from '@shared/modal/services/base-modal.service';
var TravelSuccessModalComponent = (function () {
    function TravelSuccessModalComponent(_service, _modal) {
        this._service = _service;
        this._modal = _modal;
        this.busy = true;
        this.error = {
            hasError: false,
            message: ''
        };
    }
    TravelSuccessModalComponent.prototype.putTravelMode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._service.putTravelMode()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    TravelSuccessModalComponent.prototype.close = function () {
        this._modal.close();
    };
    TravelSuccessModalComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        _a = this;
                        return [4, this._service.getCountry()];
                    case 1:
                        _a.countries = _b.sent();
                        return [3, 4];
                    case 2:
                        e_1 = _b.sent();
                        this.error = {
                            hasError: true,
                            message: 'Não foi possível buscar as taxas'
                        };
                        return [3, 4];
                    case 3:
                        this.busy = false;
                        return [7];
                    case 4: return [2];
                }
            });
        });
    };
    return TravelSuccessModalComponent;
}());
export { TravelSuccessModalComponent };
